import { ref, onUnmounted } from "vue";

export function useWebSocket(url, options = {}) {
  const {
    maxRetries = 5,
    reconnectDelay = 1000,
    onMessage = null,
    onOpen = null,
    onClose = null,
    onError = null,
  } = options;

  const socket = ref(null);
  const isConnected = ref(false);
  const retryCount = ref(0);

  let reconnectTimeout;

  const connect = () => {
    socket.value = new WebSocket(url);

    socket.value.onopen = (event) => {
      isConnected.value = true;
      retryCount.value = 0;
      if (onOpen) onOpen(event);
    };

    socket.value.onmessage = (event) => {
      if (onMessage) onMessage(event);
    };

    socket.value.onclose = (event) => {
      isConnected.value = false;
      if (onClose) onClose(event);

      // Retry logic
      if (retryCount.value < maxRetries) {
        retryCount.value++;
        reconnectTimeout = setTimeout(() => {
          connect();
        }, reconnectDelay);
      }
    };

    socket.value.onerror = (event) => {
      if (onError) onError(event);
    };
  };

  const disconnect = () => {
    if (socket.value) {
      socket.value.close();
      clearTimeout(reconnectTimeout);
    }
  };

  // Auto-connect
  //   connect();

  onUnmounted(() => {
    disconnect();
  });

  return {
    socket,
    isConnected,
    connect,
    disconnect,
  };
}
